<p-accordion>
    <ng-container *ngFor="let venue of customerService.publicCustomer.value.venues">
        <p-accordionTab>
            <ng-template pTemplate="header">
                <div class="d-flex ms-2">
                    {{venue.venueName}}
                </div>
            </ng-template>
            <ng-template pTemplate="content">
                <app-about-me-venue-detail [venueKey]="venue.venueKey"></app-about-me-venue-detail>
            </ng-template>
        </p-accordionTab>
    </ng-container>
</p-accordion>